/* eslint-disable @typescript-eslint/naming-convention */
import { GroupOwnerDto } from './GroupOwnerDto';
import { TradeClassDto } from './TradeClassDto';

export interface TradeGroupDto {
  TradeGroupID: string;
  GroupName: string;
  bActive: boolean;
  TradeClassCount: number;
  ActiveTradeClassCount: number;
  VPCompanyIDs: number[];
  TradeClasses: TradeClassDto[];
  GroupOwners: GroupOwnerDto[];

  /** Client side only */
  isDirty: boolean;
  /** Client side only */
  isInvalid: boolean;
  /** Client side only */
  isExpanded: boolean;
  /** Client side only */
  isSelected: boolean;
  /** Client side only */
  FilteredTradeClasses: TradeClassDto[];
  /** Client side only */
  isTradeClassLoaded;
  /** Client side only */
  isGroupOwnerLoaded: boolean;
}
